import { render } from "./PasswordResetSuccess.vue?vue&type=template&id=75750240&scoped=true"
import script from "./PasswordResetSuccess.vue?vue&type=script&lang=js"
export * from "./PasswordResetSuccess.vue?vue&type=script&lang=js"

import "./PasswordResetSuccess.vue?vue&type=style&index=0&id=75750240&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75750240"]])

export default __exports__